import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  settingsData: null,
  isLoading: false,
  error: null,
  success: false,
};

export const settingsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("getSettingsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getSettingsSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
    })
    .addCase("getSettingsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateSettingsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateSettingsSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("updateSettingsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateOrganizationSettingsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateOrganizationSettingsSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("updateOrganizationSettingsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateReceiptSettingsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateReceiptSettingsSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("updateReceiptSettingsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateSubscriptionSettingsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateSubscriptionSettingsSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("updateSubscriptionSettingsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("activateSubscriptionRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("activateSubscriptionSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("activateSubscriptionFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("deactivateSubscriptionRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("deactivateSubscriptionSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("deactivateSubscriptionFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("clearErrors", (state) => {
      state.error = null;
    })
    .addCase("clearSuccess", (state) => {
      state.success = false;
    });
});